export default __webpack_public_path__ + "static/media/car.308ab623.svg";